/**
 * Gedeelde API-error class — los gehouden van api.ts en mock.ts om
 * circulaire imports te voorkomen.
 */
export class ApiError extends Error {
  constructor(public status: number, public payload: unknown) {
    super(`API error ${status}`);
    this.name = "ApiError";
  }
}

export function isApiError(e: unknown): e is ApiError {
  return e instanceof ApiError;
}
